import { render, staticRenderFns } from "./profileInfos.vue?vue&type=template&id=1ab50696&scoped=true&"
import script from "./profileInfos.vue?vue&type=script&lang=js&"
export * from "./profileInfos.vue?vue&type=script&lang=js&"
import style0 from "./profileInfos.css?vue&type=style&index=0&id=1ab50696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab50696",
  null
  
)

export default component.exports